import { useEffect, useRef, useState } from 'react';
import { useRemainingQuantity } from 'lane-shared/hooks/contentState';
import { explodeFeatures } from 'lane-shared/helpers/features';

export function useContentQuantityState(content: any, changeState: any) {
  const { quantityFeature } = explodeFeatures(content?.features);
  const { quantityRemaining, fetchTotalQuantityClaimedCount, loading } =
    useRemainingQuantity(content);

  const [isButtonDisabled, setIsButtonDisabled] = useState(
    quantityFeature ? quantityRemaining === 0 : false
  );

  // Keep the latest values in refs so the second effect (keyed only on
  // changeState, to avoid looping on its own fetch result) always reads
  // current data instead of whatever was captured when it last ran.
  const latestRef = useRef({
    quantityFeature,
    quantityRemaining,
    fetchTotalQuantityClaimedCount,
  });

  latestRef.current = {
    quantityFeature,
    quantityRemaining,
    fetchTotalQuantityClaimedCount,
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchTotalQuantityClaimedCount();
      setIsButtonDisabled(quantityFeature ? quantityRemaining === 0 : false);
    };

    if (quantityFeature) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await latestRef.current.fetchTotalQuantityClaimedCount();

      const latest = latestRef.current;

      setIsButtonDisabled(
        latest.quantityFeature ? latest.quantityRemaining === 0 : false
      );
    };

    if (latestRef.current.quantityFeature || changeState) {
      fetchData();
    }
    // `quantityRemaining` is derived from this fetch's own result — keeping it
    // as a dep re-triggers the effect on every completion, looping forever.
    // Latest values are read via `latestRef` instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeState]);

  return {
    isButtonDisabled,
    loading,
  };
}
